<template>
    <div>
        <div class="row pb-4">
            <div class="col">
                <div class="text-left">
                <h3 id="" class="mb-1">Suspect Report</h3>
            </div>
            </div>
        </div>
        <div class="row pb-2">
            <div class="col">
                <div class="card border-dark">
                <div class="card-header  bg-dark text-white">Filter Option</div>
                <div class="card-body">
                    <div class="row">
                                <div class="col">
                                    <div class="form-group mb-2">
                                        <label for="" class="">Range Date</label>
                                        <!-- <input type="text" class="form-control elegant-flatpickr" id="" placeholder="Range Date"> -->
                                        <!-- <flat-pickr
                                            :config="rangePickr"
                                            placeholder="Select Date"
                                            v-model="selected.date"
                                        ></flat-pickr> -->

                                        <div class="input-group">
                                            <span   class="input-group-text bg-white" 
                                                    style=" border-top-right-radius: 0; 
                                                            border-bottom-right-radius: 0;
                                                            border-right: none;">
                                                <i  class="fas fa-calendar" 
                                                    style=" position: absolute; 
                                                            left: 10px; 
                                                            top: 50%; 
                                                            transform: translateY(-50%); 
                                                            color: #333;"></i>
                                            </span>
                                            <flat-pickr
                                                :config="rangePickr"
                                                placeholder="Select Date"
                                                v-model="selected.universalDate"
                                            ></flat-pickr>
                                        </div>

                               

                                    </div>
                                </div>
                                <div class="col">
                                    <div class="form-group mb-2">
                                        <label for="" class="">Search Distance</label>
                                        <input type="text" class="form-control" id="" placeholder="Type Distance" v-model="filter.searchDistance">
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="form-group mb-2">
                                        <label for="" class="">Part Number</label>
                                        <select class="custom-select custom-select-lg mb-3" v-model="filter.partNumber">
                                           
                                        </select>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="form-group mb-2">
                                        <label for="" class="">Alasan Suspek</label>
                                        <select class="custom-select custom-select-lg mb-3" v-model="filter.alasanSuspect">
                                           <option value="">Alasan Suspek</option>
                                           <option value="Scan beda tempat">Scan Beda Tempat</option>
                                           <option value="Scan lebih dari 5 kali">Scan Lebih Dari 5 Kali</option>
                                        </select>
                                    </div>
                                </div>
                                
                    </div>

                    <div class="row">
                        <div class="col-md-3 px-3 mb-2">
                            <button class="btn btn-primary px-2 w-100" @click="filterData()">Filter</button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="card ">
                <div class="card-body">
                    <table class="table">
                        <thead>
                            <tr>
                        
                            <th scope="col">Kode QR </th>
                            <th scope="col">Part Number</th>
                            <th scope="col">Alasan</th>
                            <th scope="col">Jumlah Scan</th>
                            <th scope="col">Tanggal Scan</th>
                            <th scope="col">*</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- <tr>
                                <th scope="row"></th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><button class="btn btn-white border-primary btn-modal" @click="seeDetail(1)">
                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="12" height="12" viewBox="0 0 50 50">
                                    <path d="M 21 3 C 11.621094 3 4 10.621094 4 20 C 4 29.378906 11.621094 37 21 37 C 24.710938 37 28.140625 35.804688 30.9375 33.78125 L 44.09375 46.90625 L 46.90625 44.09375 L 33.90625 31.0625 C 36.460938 28.085938 38 24.222656 38 20 C 38 10.621094 30.378906 3 21 3 Z M 21 5 C 29.296875 5 36 11.703125 36 20 C 36 28.296875 29.296875 35 21 35 C 12.703125 35 6 28.296875 6 20 C 6 11.703125 12.703125 5 21 5 Z"></path>
                                    </svg>
                                    </button></td>
                            </tr> -->
                            <tr v-for="data in frequentlyScannedProductShownData.slice((filter.frequentlyScannedProduct.page - 1) * filter.frequentlyScannedProduct.limit , (filter.frequentlyScannedProduct.page) * filter.frequentlyScannedProduct.limit )">
                               <td>{{ data.qrcode }}</td>
                               <td>{{ data.part_number }}</td>
                               <td>{{ data.reason }}</td>
                               <td>{{ data.total_scan }}</td>
                               <td>{{ data.scan_date }}</td>
                               <td><button class="btn btn-white border-primary btn-modal" @click="seeDetail(1)">
                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="12" height="12" viewBox="0 0 50 50">
                                    <path d="M 21 3 C 11.621094 3 4 10.621094 4 20 C 4 29.378906 11.621094 37 21 37 C 24.710938 37 28.140625 35.804688 30.9375 33.78125 L 44.09375 46.90625 L 46.90625 44.09375 L 33.90625 31.0625 C 36.460938 28.085938 38 24.222656 38 20 C 38 10.621094 30.378906 3 21 3 Z M 21 5 C 29.296875 5 36 11.703125 36 20 C 36 28.296875 29.296875 35 21 35 C 12.703125 35 6 28.296875 6 20 C 6 11.703125 12.703125 5 21 5 Z"></path>
                                    </svg>
                                    </button>
                                </td>
                            </tr>

                            
                            
                        </tbody>
                        </table>
                        <hr class="mt-3">
                        <div style="display: flex;align-items: center;" class="w-100">
                            <div class="mr-3" style="color: #CBCBCB; font-size: 1.2em;">
                                Showing {{(filter.frequentlyScannedProduct.page - 1) * filter.frequentlyScannedProduct.limit + 1}} - {{
                                    (filter.frequentlyScannedProduct.page) * filter.frequentlyScannedProduct.limit < frequentlyScannedProductShownData.length ? (filter.frequentlyScannedProduct.page) * filter.frequentlyScannedProduct.limit : frequentlyScannedProductShownData.length
                                }} of {{frequentlyScannedProductShownData.length}} items
                            </div>
                            <button class="btn mr-2" @click="filter.frequentlyScannedProduct.page = 1" :disabled="filter.frequentlyScannedProduct.page === 1">&laquo;</button>
                            <button class="btn mr-2" @click="filter.frequentlyScannedProduct.page -= 1" :disabled="filter.frequentlyScannedProduct.page === 1">&lsaquo;</button>
                            <span>Page {{ filter.frequentlyScannedProduct.page }} of {{ Math.ceil(frequentlyScannedProductShownData.length / filter.frequentlyScannedProduct.limit )}}</span>
                            <button class="btn ml-2" @click="filter.frequentlyScannedProduct.page += 1" :disabled="filter.frequentlyScannedProduct.page >= Math.ceil(frequentlyScannedProductShownData.length / filter.frequentlyScannedProduct.limit )">&rsaquo;</button>
                            <button class="btn ml-2" @click="filter.frequentlyScannedProduct.page = Math.ceil(frequentlyScannedProductShownData.length / filter.frequentlyScannedProduct.limit )" :disabled="filter.frequentlyScannedProduct.page >= Math.ceil(frequentlyScannedProductShownData.length / filter.frequentlyScannedProduct.limit )">&raquo;</button>
                        </div>
                  

                </div>
            </div>
            </div>
        </div>

        <!-- <div v-if="showModal" class="modal fade show" tabindex="-1" role="dialog" style="display: block;" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalCenterTitle">Modal title</h5>
                <button type="button" class="close" @click="closeModal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {{ idnya }}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
            </div>
            </div>
        </div>
        </div>
        <div v-if="showModal" class="modal-backdrop fade show"></div> -->


        <!-- <suspect-scan-map
            v-if="modal.map"
            :filter="modal.mapData"
            @closeModal="modal.map = false"
        ></suspect-scan-map> -->


    </div>




</template>

<script>

    import moment from 'moment';
    import qs from 'qs';
    import debounce from 'debounce';
    import Multiselect from 'vue-multiselect';

    import customFilter from '@/components/filter/customFilter'
    
    import suspectScanMap from './children/SuspectReportModal.vue'


    export default {
            metaInfo : {
                title : 'Suspect Report'
            },
            data(){

                let startOfYear = new moment().startOf('year')
                let endOfYear = new moment().endOf('year')

                let formattedStartOfYear = startOfYear.format('Y-MM-DD')
                let formattedEndOfYear = endOfYear.format('Y-MM-DD')

                return{
                    moment,
                    rangePickr: {
                        mode: 'range',
                        dateFormat: "d/m/Y",
                        altInput: true,
                        altFormat: "d/m/Y",
                        altInputClass: 'form-control input elegant-flatpickr border-left-0'
                    },
                    selected : {
                            // dateButtonsIndex : 2,
                        date : `${startOfYear.format('DD/MM/Y')} to ${endOfYear.format('DD/MM/Y')}`,
                        // topScanDate : `${startOfYear.format('DD/MM/Y')} to ${endOfYear.format('DD/MM/Y')}`,
                        universalDate : `${startOfYear.format('DD/MM/Y')} to ${endOfYear.format('DD/MM/Y')}`
                    },
                    filter : {
                        searchDistance : null,
                        part_number : null,
                        alasanSuspect : null,
                      
                        frequentlyScannedProduct : {
                            page : 1,
                            limit : 10
                        },
                       
                        // period : 'This Year',
                    },

                    frequentlyScannedProduct : [],
                }

            },
            mounted(){
                this.loadFrequentlyScannedProduct();

            },
            watch :{

                'selected.universalDate' : function () {
                    console.log('tanggal ', this.selected.universalDate);
                    this.selected.date = this.selected.universalDate;


                    // this.selected.topScanDate = this.selected.universalDate
                    
                    // this.debounceMethod(this , [{
                    //     functionName : 'loadFrequentlyScannedProduct',
                    //     filterVar : 'frequentlyScannedProductApi',
                    //     selectedVar : 'date'
                    // }]) 
                },

                // 'modelDistance' : function () {
                //     // console.log('tanggal ', this.selected.universalDate);
                //     this.filter.mDistance = this.filter.modelDistance;
                // },
                // 'selected.universalDate' : function () {
                //     // console.log('tanggal ', this.selected.universalDate);
                //     this.searchDistance = this.selected.universalDate;
                // },
                // 'selected.universalDate' : function () {
                //     // console.log('tanggal ', this.selected.universalDate);
                //     this.searchDistance = this.selected.universalDate;
                // },



            },
            computed : {
                frequentlyScannedProductShownData () {
                    return this.frequentlyScannedProduct
                        .filter(x=> this.filter.part_number == null || x.part_number == this.filter.part_number)
                },
                // frequentlyScannedSerialNumberShownData () {
                //     return this.highlightData.topScan
                //         .filter(x=> this.filter.topScan.material_no == null || x.material_no == this.filter.topScan.material_no)
                //         .filter(x=> this.filter.topScan.serial_number == null || x.serial_number == this.filter.topScan.serial_number)
                // },
                // ...mapState('maps', {
                //     isIndonesia : state => state.isIndonesia
                // })
            },
            methods:{
                async loadFrequentlyScannedProduct() {
                    try {
                        this.frequentlyScannedProduct = []
                        // let resp = await this.$http.get('/dashboard/frequently-scanned-product?' + qs.stringify(this.filter.frequentlyScannedProductApi))

                        let dateRange = this.selected.date;

                        let [startDate, endDate] = dateRange.split(' to ');

                        let [startDay, startMonth, startYear] = startDate.split('/');
                        let formattedStartDate = `${startYear}-${startMonth}-${startDay}`;

                        let [endDay, endMonth, endYear] = endDate.split('/');
                        let formattedEndDate = `${endYear}-${endMonth}-${endDay}`;

                        // let resp = await this.$http.get('suspect-report/?start=2024-05-01&end=2024-05-29')

                        let apiEndpoint = `suspect-report/?start=${formattedStartDate}&end=${formattedEndDate}`;

                        if (this.filter.part_number) {
                            apiEndpoint += `&part_number=${this.filter.part_number}`;
                        }
                        if (this.filter.searchDistance) {
                            apiEndpoint += `&distance=${this.filter.searchDistance}`;
                        }
                        if (this.filter.alasanSuspect) {
                            apiEndpoint += `&reason=${this.filter.alasanSuspect}`;
                        }

                        console.log(apiEndpoint);
                        let resp = await this.$http.get(apiEndpoint);

                        
                        this.frequentlyScannedProduct = resp.data.data;
                        // console.log(this.frequentlyScannedProduct);

                        // console.log(this.filter.alasanSuspect);
                        // console.log(this.filter.frequentlyScannedProductApi.start);

                    }
                    catch(err) {
                        console.log(err)
                    }
                },

                filterData(){
                    // console.log(this.selected.date);
                    this.loadFrequentlyScannedProduct();
                }
            }

    }
</script>


<style scoped>
    .btn-pretty {
        background-color: #DBEBFF;
        color: #267CE5;
    }
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }
    .statsData {
        padding : 10px 7px;
    }

    .stats {
        font-size: 1.3rem;
        font-weight: 600;
    }

    .bg-kabupaten {
        background-color: darkorange;
    }
    .bg-kecamatan {
        background-color :blueviolet;
    }
    .bg-desakel {
        background-color: darkslategray;
    }
    .bg-tps {
        background-color:dodgerblue;
    }

    .column-region {
        height: 400px;
        overflow-y:scroll;
    }
</style>

<style scoped>
    .not-selected-button {
        color: #4B4B4B;
        background-color: #FFFFFF;
        border: none;
    }
    .horizontal-line {
        border-top: 1px solid #a2a2a2;
        margin: 5px 0 ;
        width: 100%;
        height: 1px;
    }

    .ahm-button-circular {
        width: 40px; /* Set the width and height to the same value for a perfect circle */
        height: 40px;
        border-radius: 50%; /* Makes the button circular */
        background-color: #D8E4FF; /* Sets the background color */
        padding: 10px 20px; /* Adjust padding to fit your content */
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: none;
        outline: none;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Adjust shadow values as needed */
    }

    .ahm-modal-description {
        text-align: left;
        font-size: 14px;
        letter-spacing: 0px;
        color: #2D2D2D;
        opacity: 1;
    }

    .ahm-modal-title {
        text-align: left;
        font-size: 14px;
        letter-spacing: 0px;
        color: #4B4B4B;
        opacity: 1;
    }

    .ahm-modal-body {
        /* Set a fixed width and height for the container, or use relative units like % if needed */
        width: 100%;
        height: 100%;
        overflow: hidden; /* Hide any overflowing content */
    }

    .modal {
        display: block; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: hidden;
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    }

    .modal-content {
        background-color: #fefefe;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        border: 1px solid #888;
        width: 45%;
        overflow: hidden;
        max-height: 80vh;
    }

    .close {
        color: black;
        float: right;
        font-size: 28px;
        font-weight: bold;
    }

    .close:hover,
    .close:focus {
        color: black;
        text-decoration: none;
        cursor: pointer;
    }
</style>

<style scoped>
    .ahm-table thead tr th {
        pointer-events: none;
    }

    .ahm-table thead tr th,
    .table-title {
        font-weight: normal;
        color: #BCBCBC;
        text-align: left !important;
    }

    .ahm-table thead tr th,
    .ahm-table tbody tr td {
        vertical-align: middle;
        font-size: 14px;
        text-align: left !important;
    }

    .ahm-table.ahm-table-cr thead tr th:last-child {
        text-align: center !important;
    }
    .ahm-table.ahm-table-cr tbody tr td:nth-last-child(2) {
        text-align: right !important;
    }

    .ahm-table .no-border td {
        border: 0;
        padding: 5px;
    }    

    .ahm-table.table-sequre thead tr th {
        border-bottom: 1px solid #E8E8E8 !important;
        padding-top: 1.25rem !important;
        padding-bottom: 1.25rem !important;
        color: #4B4B4B !important;
        font-weight: normal !important;
    }

    .ahm-table.table-sequre tbody tr td {
        min-width: 0px; /* Adjust the width as needed */
    }

    .table td, .table th {
        padding: 8px;
        vertical-align: top;
        border-top: 1px solid #e4e7ea;
    }

    .prefix-icon {
        position: absolute;
        left: 15px;
        top: 50%;
        transform: translateY(-50%);
    }

    .prefix-input .elegant-flatpickr {
        padding-left: 35px;
    }

    .hidden .elegant-flatpickr {
        opacity: 0;
        position: absolute;
        z-index: -1;
    }

    .customer-report-multiselect .multiselect__placeholder {
        color: black;
    }
</style>